import React from "react";
import styled from "styled-components";
import About from "../About/about"
import Proyecto from "../Proyectos/Proyecto"
import {Route, NavLink, Link, Routes} from 'react-router-dom';   

const Ul = styled.ul`
    list-style: none;
    display: flex;
    flex-flow: row nowrap;
    
    a {
        box-shadow: inset 0 0 0 0 #54b3d6;
        color: #54b3d6;
        margin: 5px;
        transition: color .3s ease-in-out, box-shadow .3s ease-in-out;
    }

    a {
        font-family: 'Poppins', sans-serif;
        font-size: 27px;
        font-weight: 700;
        line-height: 1.5;
        text-decoration: none;
        color: #54b3d6;
    }

    a:hover {
        color: #fff;
        box-shadow: inset 200px 0 0 0 #54b3d6;
        cursor: pointer;
    }

    @media (max-width: 768px) {
        flex-flow: column wrap;
        background-color: #3F0071;
        color: #fff;
        position: fixed;
        opacity: ${({ open }) => open ? '1' : '0'};
        transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
        top: 0;
        right: 0;
        height: 100vh;
        min-width: calc(100vw - 15rem + 50px);
        padding-top: 3.5rem;
        transition: transform 0.3s ease-in-out;

        ul li {
            color: #fff;
        }
    }
`;

const RightNav = ({ open }) => {
    return (
        <Ul open={open}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            {/* <li><Link to="/proyectos">Proyectos</Link></li> */}
            <Routes>
                <Route path="/" element={<></>} />
                {/* <Route path="/about" element={<About />} exact/> */}
                {/* <Route path="/proyectos" element={< Proyecto />} exact/> */}
            </Routes>
        </Ul>
    );
}

export default RightNav;